"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CHECKBOX_BUTTON_ICON_NAME", {
  enumerable: true,
  get: function () {
    return _Icon.ICON_NAME;
  }
});
Object.defineProperty(exports, "CHECKBOX_BUTTON_SIZE", {
  enumerable: true,
  get: function () {
    return _ButtonIcon.BUTTON_ICON_SIZE;
  }
});
Object.defineProperty(exports, "CHECKBOX_BUTTON_STYLE_TYPE", {
  enumerable: true,
  get: function () {
    return _Button.BUTTON_STYLE_TYPE;
  }
});
var _Button = require("b2b-components/theme/components/Button");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
//# sourceMappingURL=CheckboxButton.types.js.map